<template>
    <div class="estadisticas-envasado card p-3 mb-4">
  
      <!-- Cabecera -->
      <div class="d-flex justify-content-between align-items-center mb-3">
        <h6 class="mb-0 text-primary">
          <font-awesome-icon :icon="['fas', 'chart-bar']" class="me-2" />
          Estadísticas de Envasado
        </h6>
        <button class="btn btn-sm btn-outline-secondary" @click="colapsado = !colapsado">
          <font-awesome-icon :icon="['fas', colapsado ? 'chevron-down' : 'chevron-up']" />
        </button>
      </div>
  
      <!-- Contenido colapsable -->
      <div v-if="!colapsado">
        <p><strong>Ganancia Total Estimada:</strong> {{ gananciaTotal.toFixed(2) }} {{ monedaActual?.codigo || '-' }}</p>
        <p><strong>Total Unidades Envasadas:</strong> {{ totalUnidades }}</p>
        <p><strong>Total Gramos Envasados:</strong> {{ totalGramos.toFixed(1) }} g</p>
  
        <h6 class="mt-3">Resumen por Tipo de Producto:</h6>
        <ul class="list-group small">
          <li
            v-for="(resumen, tipo) in resumenPorTipo"
            :key="tipo"
            class="list-group-item"
          >
            <div class="d-flex justify-content-between">
              <strong>{{ tipo }}</strong>
              <span>{{ resumen.ganancia.toFixed(2) }} {{ monedaActual?.codigo || '-' }}</span>
            </div>
            <div class="small text-muted mt-1">
              {{ resumen.unidades }} unidades — {{ resumen.gramos.toFixed(1) }} g
            </div>
          </li>
        </ul>
      </div>
  
    </div>
  </template>
  
  <script>
  import axios from "@/axios";
  import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
  
  export default {
    name: "EstadisticasProductoEnvasado",
    components: { FontAwesomeIcon },
    props: {
      envasados: {
        type: Array,
        required: true
      }
    },
    data() {
      return {
        colapsado: true, // colapsado por defecto
        monedaActual: null,
        clubActual: this.$store.getters.getClubActual
      };
    },
    computed: {
      gananciaTotal() {
        return this.envasados.reduce((total, e) => {
          if (e.anulado) return total;
          return total + (e.precio_unitario * e.cantidad_unidades);
        }, 0);
      },
      totalUnidades() {
        return this.envasados.reduce((total, e) => {
          if (e.anulado) return total;
          return total + e.cantidad_unidades;
        }, 0);
      },
      totalGramos() {
        return this.envasados.reduce((total, e) => {
          if (e.anulado) return total;
          return total + (e.peso_por_unidad * e.cantidad_unidades);
        }, 0);
      },
      resumenPorTipo() {
        const resumen = {};
        this.envasados.forEach(e => {
          if (e.anulado) return;
  
          if (!resumen[e.tipo_producto]) {
            resumen[e.tipo_producto] = {
              ganancia: 0,
              unidades: 0,
              gramos: 0
            };
          }
  
          resumen[e.tipo_producto].ganancia += (e.precio_unitario * e.cantidad_unidades);
          resumen[e.tipo_producto].unidades += e.cantidad_unidades;
          resumen[e.tipo_producto].gramos += (e.peso_por_unidad * e.cantidad_unidades);
        });
        return resumen;
      }
    },
    methods: {
      async fetchMonedaActual() {
        try {
          const res = await axios.get('/api/moneda_actual', {
            params: { club_id: this.clubActual.id }
          });
          this.monedaActual = res.data;
        } catch (error) {
          console.error("Error al obtener la moneda actual", error);
        }
      }
    },
    mounted() {
      this.fetchMonedaActual();
    }
  };
  </script>
  
  <style scoped>
  .estadisticas-envasado {
    background-color: #f8f9fa;
    border-radius: 0.5rem;
  }
  
  h6 {
    font-weight: 600;
  }
  
  ul.list-group {
    margin-bottom: 0;
  }
  
  .list-group-item {
    padding: 0.4rem 0.75rem;
  }
  
  .btn-sm {
    font-size: 0.75rem;
  }
  </style>
  